import React from "react";
import "../../styles/pages-styles/landing-layout-pages-styles/SignUp.css";

const SignUp = () => {
  return (
    <div>
      <div className="signup-container">
        <div className="signup-card">
          {/* Logo and Header */}
          <div className="header">
            <h1 className="logo">
              <a id="home" href="/">
              Pass<span className="logo-highlight">Medicnce</span>
              </a>
            </h1>
            <p className="subtitle">Create your account</p>
          </div>

          {/* Form */}
          <form className="signup-form">
            {/* Full Name */}
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Enter your full name"
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="you@example.com"
              />
            </div>

            {/* Password */}
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Create a password"
              />
            </div>

            {/* Confirm Password */}
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm your password"
              />
            </div>

            {/* Terms and Conditions */}
            <div className="form-group-checkbox">
              <input id="agreeToTerms" name="agreeToTerms" type="checkbox" />
              <label htmlFor="agreeToTerms">
                I agree to the{" "}
                <a href="#" className="link">
                  Terms and Conditions
                </a>{" "}
                and{" "}
                <a href="#" className="link">
                  Privacy Policy
                </a>
              </label>
            </div>

            {/* Submit Button */}
            <button type="submit" className="submit-button">
              Create Account
            </button>

            {/* Login Link */}
            <div className="login-link">
              <p>
                Already have an account?{" "}
                <a href="login" className="link">
                  Log in
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
